import { connect } from "react-redux";
import DashboardPP from "./DashboardNewUI/DashboardPP";
import * as widgetTypes from "./widgets/WidgetTypes";
import { submitCharitySurvey } from "../../actions/charityActions";
import {
  initNotificationsWidget,
  removeNotificationsById,
} from "../../actions/notificationActions";
import { getShortLivedToken } from "../../actions/loginActions";

const mapStateToProps = ({ common, app, notification, localization }) => {
  const { client } = app;
  const { notifications } = notification;
  const { selectedLanguage } = localization;
  const filteredNotifications = notifications.filter(
    notification => notification.id !== widgetTypes.NOTIFICATION_DOWNLOAD_CARD
  );
  const isNewUI = common.clientSettings.newUIFlag;

  return {
    notifications: filteredNotifications,
    commonConfig: common,
    selectedLanguage,
    client,
    isNewUI,
  };
};

const mapDispatchToProps = {
  submitCharitySurvey,
  initNotificationsWidget,
  removeNotificationsById,
  getShortLivedToken,
};

const DashboardContainerPP = connect(mapStateToProps, mapDispatchToProps)(DashboardPP);
export default DashboardContainerPP;



// WEBPACK FOOTER //
// ./components/dashboard/DashboardContainerPP.js